import { useConfiguration } from 'store/hooks/useConfiguration';
import App from './App';

const AppContainer = props => {
  const { locale } = useConfiguration();

  return <App {...props} locale={locale} />;
};

export default AppContainer;
